import { useEffect } from 'react';

import { useConfiguration } from 'redpoints-front-common-rp10/hooks';

const IpOfflineServices = (): null => {
  const { portalIpOfflineServices } = useConfiguration();

  useEffect(() => {
    if (portalIpOfflineServices) {
      window.open(portalIpOfflineServices, '_blank');
      window.history.back();
    }
  }, [portalIpOfflineServices]);

  return null;
};

export default IpOfflineServices;
